// Initials avatars for users without a profile picture (US 9365).
// The colour comes from the user id, so a user has the same colour on every page and device.

const COLORS = [
  '#2B8A80', '#3B6FD8', '#7B5CD6', '#D2557A', '#C77C1A', '#1F8FB0',
  '#5E8C2F', '#B5487A', '#4F5BD5', '#A0522D', '#0F7B5C', '#6B6FA8'
];

function hash(text) {
  let value = 0;
  for (let i = 0; i < text.length; i++) {
    value = (value * 31 + text.charCodeAt(i)) >>> 0;
  }
  return value;
}

// First letter of the first and the last name ("Claus Bock Goldman" -> "CG"); the email when there is no name
export function userInitials(user) {
  let words = ((user && user.name) || '').trim().split(/\s+/).filter(Boolean);

  if (!words.length) {
    let email = (user && user.email) || '';
    return email ? email.charAt(0).toUpperCase() : '?';
  }

  let first = words[0].charAt(0);
  let last = words.length > 1 ? words[words.length - 1].charAt(0) : '';

  return (first + last).toUpperCase();
}

export function userColor(user) {
  let id = user && user.id;
  let key = Number.isInteger(id) ? id : hash(String((user && (user.email || user.name)) || ''));

  return COLORS[key % COLORS.length];
}

function escapeXml(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// An SVG image, so it works wherever an avatar URL is used (img src or CSS background).
// No quotes or parentheses in the markup, because callers put it in an unquoted CSS url().
export function initialsAvatarUrl(user) {
  let initials = escapeXml(userInitials(user));
  let fontSize = initials.length > 1 ? 40 : 46;
  let svg = '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'100\' height=\'100\' viewBox=\'0 0 100 100\'>' +
    '<rect width=\'100\' height=\'100\' fill=\'' + userColor(user) + '\'/>' +
    '<text x=\'50\' y=\'50\' dy=\'.35em\' text-anchor=\'middle\' fill=\'#fff\' font-family=\'Helvetica Neue,Arial,sans-serif\' font-weight=\'600\' font-size=\'' + fontSize + '\'>' +
    initials + '</text></svg>';

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg).replace(/'/g, '%27');
}

// The uploaded picture when there is one, otherwise the initials avatar
export function userAvatarUrl(user, large) {
  let picture = user && (large ? (user.avatar_large || user.avatar) : user.avatar);

  return picture || initialsAvatarUrl(user);
}
